import React, { lazy } from 'react'
import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine'
import { Ad } from '../types'
import AdComponent from './components/AdComponent'

const InspectorLazy = lazy(() => import('./Inspector'))

interface Props {
    ads: Ad[]
    taxonomySlug: string | null
    minHeight?: number
    isSpace?: boolean
    desktopOnly?: boolean
    mobileOnly?: boolean
}

const Block: React.FC<Props> = ({
    ads,
    taxonomySlug,
    minHeight,
    isSpace,
    desktopOnly,
    mobileOnly,
}) => {
    useInspectorControl(InspectorLazy, [])
    const { isEditing } = useEditor()

    return (
        <BlockWrapper.Div>
            <AdComponent
                ads={ads}
                taxonomySlug={taxonomySlug}
                minHeight={minHeight}
                isSpace={isSpace}
                desktopOnly={desktopOnly}
                mobileOnly={mobileOnly}
                isEditing={isEditing}
            />
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block,
    smartProps: {
        ads: smartProps.array.withDefault([]),
        taxonomySlug: smartProps.string.withDefault(null),
        minHeight: smartProps.number.withDefault(250),
        desktopOnly: smartProps.bool.withDefault(false),
        mobileOnly: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Publicité',
    },
})
